import { ChatMessage, ChatMessageAutomationAction, ChatMessageToolCall, ChatStatusItem } from "@/schema"
import type { UIMessage } from "ai"

export const CHAT_MODEL_SELECTIONS = [
  "gpt_latest",
  "gpt_advanced",
  "gpt_low",
  "claude_sonnet_latest",
  "claude_opus_latest",
] as const

export type ChatModelSelection = (typeof CHAT_MODEL_SELECTIONS)[number]

export interface ChatUICohort {
  id: string
  record_type: string
  description: string
  record_count: number
}

export interface ChatUIActionLink {
  type: string
  id: string
}

export interface ChatUIStorageFile {
  file_id?: string
  file_name?: string
  file_type?: string
  file_size?: number
  provider?: string
  source?: string
  download_url?: string
  view_url?: string
}

export interface ChatUIPromptSnippet {
  prompt_snippet_id?: string | null
  prompt_snippet_key?: string
  system_key?: string | null
  title?: string
  content?: string
  icon?: string
  color?: string
  chat_type?: string
}

export interface ChatUIMention {
  record_type?: string
  record_id?: string
  label: string
}

export interface ChatUIDashboardWidget {
  id: string
  title: string
}

export interface ChatUIProgressUpdate {
  message?: string | null
  visible: boolean
  timestamp: string
}

export type ChatUIDataParts = {
  status: ChatStatusItem
  "progress-update": ChatUIProgressUpdate
  "tool-call": ChatMessageToolCall
  "automation-action": ChatMessageAutomationAction
  cohort: ChatUICohort
  "action-link": ChatUIActionLink
  "storage-file": ChatUIStorageFile
  "dashboard-widget": ChatUIDashboardWidget
  "prompt-snippet": ChatUIPromptSnippet
  mention: ChatUIMention
  disclaimer: { text: string }
}

export type ChatUIMessage = UIMessage<{ created_at?: string; completed_at?: string }, ChatUIDataParts>

export interface ChatThread {
  id: string
  created_at: Date
  updated_at: Date
  chat_messages: ChatMessage[]
  ui_messages?: ChatUIMessage[]
  chat_threadable_id: string
  chat_threadable_type: string
  book_id?: string | null
  model_selection: ChatModelSelection
  active_stream_id?: string | null
  message_count?: number
  first_message_content?: string | null
  first_message_date?: string | null
  last_user_message_content?: string | null
}
